import type { SimulacaoBannerProps } from "./types-simulacao-banner";
import { useSimulacaoBanner } from "./use-simulacao-banner";
import { SimulacaoBannerView } from "./view-simulacao-banner";

export function SimulacaoBanner(props: SimulacaoBannerProps) {
  const vm = useSimulacaoBanner(props);

  return <SimulacaoBannerView {...vm} />;
}

export type * from "./types-simulacao-banner";
